var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6215 4.242C16.0489 4.49527 15.4417 4.6616 14.82 4.7355C15.4753 4.34357 15.9658 3.72676 16.2 3C15.585 3.366 14.9107 3.6225 14.208 3.76125C13.7359 3.25618 13.1102 2.92122 12.4282 2.80844C11.7461 2.69565 11.0459 2.81137 10.4364 3.13759C9.82692 3.46381 9.34227 3.98226 9.05781 4.61234C8.77336 5.24242 8.70504 5.94883 8.86348 6.62175C7.61631 6.55924 6.39623 6.23514 5.28244 5.6705C4.16866 5.10585 3.18607 4.31328 2.39848 3.34425C2.1197 3.82309 1.97319 4.36742 1.97398 4.9215C1.97398 6.009 2.52748 6.96975 3.36898 7.53225C2.87099 7.51657 2.38395 7.38208 1.94848 7.14V7.179C1.94863 7.90327 2.19926 8.60521 2.65786 9.16579C3.11647 9.72638 3.75484 10.1111 4.46473 10.2547C4.00244 10.38 3.51771 10.3985 3.04723 10.3087C3.24738 10.9322 3.63748 11.4774 4.16292 11.8681C4.68836 12.2588 5.32282 12.4753 5.97748 12.4875C5.32684 12.9985 4.58186 13.3762 3.78514 13.5991C2.98842 13.822 2.15557 13.8857 1.33423 13.7865C2.768 14.7086 4.43705 15.1981 6.14173 15.1965C11.9115 15.1965 15.0667 10.4167 15.0667 6.2715C15.0667 6.1365 15.063 6 15.057 5.8665C15.6711 5.42262 16.2012 4.87276 16.6222 4.24275L16.6215 4.242Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.055277c4cc9de82e7a61385724d9fa3a.svg";
export { ForwardRef as ReactComponent };